import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Dialog, DialogClose, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger } from "../ui/dialog";

const STEPS = [
  ["🎰", "Gira lo SPIN e scegli un personaggio."],
  ["🏴‍☠️", "Assegnalo a uno dei ruoli liberi."],
  ["✨", "I ruoli evidenziati sono quelli in cui rende meglio, ma puoi schierarlo dove vuoi."],
  ["🐌", "Hai una Lumacofonata: usala al momento giusto per cambiare la ciurma proposta dallo SPIN."],
  ["🏝️", "Completa la ciurma e scopri fin dove arriverai."],
];

export const HowToPlay = () => (
  <Dialog>
    <DialogTrigger
      className="mt-3 text-[12px] font-semibold text-[#506780] underline decoration-dotted underline-offset-4 hover:text-[#147E9D] transition-colors"
      data-testid="how-to-play-open"
    >
      ⓘ Come si gioca?
    </DialogTrigger>
    <DialogPortal>
      <DialogOverlay className="bg-black/60 backdrop-blur-[2px]" data-testid="how-to-play-overlay" />
      <DialogPrimitive.Content
        aria-describedby={undefined}
        className="fixed z-50 inset-3 sm:inset-auto sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:w-full sm:max-w-md overflow-y-auto rounded-[28px] bg-white text-[#14233D] p-6 pt-7 shadow-[0_8px_0_#7433C1] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0"
        data-testid="how-to-play-modal"
      >
        <DialogClose
          className="absolute right-4 top-4 w-10 h-10 rounded-full bg-[#EAF7FF] text-[#14233D] flex items-center justify-center active:scale-95 transition-transform"
          aria-label="Chiudi"
          data-testid="how-to-play-close"
        >
          <X size={20} />
        </DialogClose>
        <DialogTitle className="font-display text-2xl leading-none pr-12 mt-1">COME SI GIOCA?</DialogTitle>
        <ul className="mt-6 space-y-4" data-testid="how-to-play-steps">
          {STEPS.map(([icon, text]) => (
            <li key={text} className="flex gap-3 text-[15px] leading-snug font-medium">
              <span className="text-xl leading-none shrink-0" aria-hidden>{icon}</span>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </DialogPrimitive.Content>
    </DialogPortal>
  </Dialog>
);
